import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class TranslationService {

    public success: string;
    public yes: string;
    public no: string;
    public confirmation: string;
    public deletedCorrectly: string;
    public deletionConfirmationQuestion: string;

    public changesSavedCorrectly: string;
    public savingChanges: string;
    public user: string;
    public role: string;
    public permission: string;
    public userName: string;
    public password: string;
    public confirmPassword: string;
    public firstName: string;
    public lastName: string;
    public documentNumber: string;
    public birthdate: string;
    public phoneNumber: string;
    public photo: string;
    public student: string;
    public payment: string;
    public person: string;
    public medicalLetter: string;
    public teacher: string;
    public loading: string;
    public new: string;
    public menu: string;

    constructor(private translateService: TranslateService) {
        this.translateService.get([
            'LABELS.SUCCESS',
            'LABELS.YES',
            'LABELS.NO',
            'LABELS.CONFIRMATION',
            'LABELS.DELETED_CORRECTLY',
            'LABELS.DELETION_CONFIRMATION_QUESTION',

            'LABELS.CHANGES_SAVED_CORRECTLY',
            'LABELS.SAVING_CHANGES',
            'LABELS.USER',
            'LABELS.CLIENT',
            'LABELS.ROLE',
            'LABELS.PERMISSION',
            'FIELDS.USERNAME',
            'FIELDS.PASSWORD',
            'FIELDS.CONFIRM_PASSWORD',
            'FIELDS.FIRST_NAME',
            'FIELDS.LAST_NAME',
            'FIELDS.DOCUMENT_NUMBER',
            'FIELDS.BIRTHDATE',
            'FIELDS.PHONE_NUMBER',
            'FIELDS.PHOTO',
            'LABELS.STORE',
            'LABELS.STUDENT',
            'LABELS.PERSON',
            'LABELS.MEDICALLETTER',
            'LABELS.TEACHER',
            'LABELS.PAYMENT',
            'LABELS.NEW',
            'LABELS.MENU',
            'LABELS.LOADING']).subscribe(res => {
                ////console.log('TranslationService > constructor > translateService > res', res);
                this.success = res['LABELS.SUCCESS'];
                this.yes = res['LABELS.YES'];
                this.no = res['LABELS.NO'];
                this.confirmation = res['LABELS.CONFIRMATION'];
                this.deletedCorrectly = res['LABELS.DELETED_CORRECTLY'];
                this.deletionConfirmationQuestion = res['LABELS.DELETION_CONFIRMATION_QUESTION'];

                this.changesSavedCorrectly = res['LABELS.CHANGES_SAVED_CORRECTLY'];
                this.savingChanges = res['LABELS.SAVING_CHANGES'];
                this.user = res['LABELS.USER'];
                this.role = res['LABELS.ROLE'];
                this.permission = res['LABELS.PERMISSION'];
                this.userName = res['FIELDS.USERNAME'];
                this.password = res['FIELDS.PASSWORD'];
                this.confirmPassword = res['FIELDS.CONFIRM_PASSWORD'];
                this.firstName = res['FIELDS.FIRST_NAME'];
                this.lastName = res['FIELDS.LAST_NAME'];
                this.documentNumber = res['FIELDS.DOCUMENT_NUMBER'];
                this.birthdate = res['FIELDS.BIRTHDATE'];
                this.phoneNumber = res['FIELDS.PERMISSION'];
                this.photo = res['FIELDS.PHOTO'];
                this.student = res['LABELS.STUDENT'];
                this.new = res['LABELS.NEW'];
                this.menu = res['LABELS.MENU'];
                this.payment = res['LABELS.PAYMENT'];
                this.person = res['LABELS.PERSON'];
                this.medicalLetter = res['LABELS.MEDICALLETTER'];
                this.teacher = res['LABELS.TEACHER'];
                this.loading = res['LABELS.LOADING'];
            });
    }

    public translate(key: string, value: string, callback?: any) {
        this.translateService.get(key, { value: value }).subscribe((res: string) => {
            if (!!callback) {
                callback(res);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/translation/translation.service.ts